module.exports = __webpack_public_path__ + "static/img/iconGouBlue.59f5017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelNew/iconGouBlue.png
// module id = 0oH/
// module chunks = 1